// Generated by scripts/generate-icons.ts from @phosphor-icons/react; change the table there.
import { icon } from "#components/icons/icon";

export const CircleHalfIcon = icon(
  "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24ZM40,128a88.1,88.1,0,0,1,88-88V216A88.1,88.1,0,0,1,40,128Z",
);
